import PlaceholderPicture from '@assets/images/placeholder.png';
import useLanguageNavigate from '@hooks/useLanguageNavigate';
import { useTruncate } from '@hooks/useTruncate';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useUsersStore } from 'services/users';

const flagCDN = 'https://flagcdn.com/w20/';

interface CardSpecialistInfoProps {
	specialist: any;
	channel?: any;
	monitoringId?: string;
	onChat?: (monitoringId: string) => void;
	chatLoading?: boolean;
}

export const CardSpecialistInfo = ({
	specialist,
	channel,
	monitoringId,
	onChat,
	chatLoading,
}: CardSpecialistInfoProps) => {
	const { t } = useTranslation();
	const { navigateWithLanguage } = useLanguageNavigate();
	const { user } = useUsersStore();
	const { truncate } = useTruncate();

	const specialistProfilePicture = specialist?.profile_image
		? `${specialist?.profile_image}`
		: PlaceholderPicture;
	const userRole = user?.role?.toLowerCase();

	const handleChatClick = () => {
		if (onChat && monitoringId) {
			onChat(monitoringId);
		} else if (channel?.id) {
			// Fallback to direct navigation if channel is already available
			navigateWithLanguage(`/${userRole}/chats?channelId=${channel.id}`);
		}
	};

	return (
		<div className="flex items-center gap-4 p-4 max-xsm:flex-col max-xsm:items-start">
			<img src={specialistProfilePicture} className="w-16 h-16 rounded-lg object-cover shadow-md" />
			<div>
				<h2 className="font-bold text-base text-dark">
					{truncate(`${specialist?.first_name} ${specialist?.last_name}`, 20)}
				</h2>
				<p className="text-dark text-xs flex gap-2 items-center justify-start">
					<img
						src={`${flagCDN}${specialist?.country.alhpa_two.toLowerCase()}.png`}
						alt={specialist?.country.name}
					/>
					<span className="text-dark text-xs">{specialist?.country.name}</span>
				</p>
			</div>
			<div className="ml-auto max-xsm:ml-0">
				<Button
					className="underline"
					sx={{ gap: 1 }}
					onClick={handleChatClick}
					disabled={chatLoading || (!onChat && !channel?.id)}
					loading={chatLoading}
				>
					<QuestionAnswerIcon />
					{t('chat')}
				</Button>
			</div>
		</div>
	);
};

export default CardSpecialistInfo;
